<template>
  <div>
    <div class="text-center">
      <div class="pa-4 mt-4 border rounded-circle mb-8 mx-auto d-inline-block">
        <v-img width="48" height="48" contain :src="$asset('img/icons/person-happy.svg')" eager />
      </div>
      <div class="text-h1 mb-2">{{ queryData.firstName }} {{ queryData.lastName }}</div>
      <div class="text-body-small grey-darken-1--text mb-12">
        {{ $t('aeskulab.formButtons.text') }}
      </div>
    </div>
    <div class="grey rounded pa-4 mb-6">
      <v-row>
        <v-col cols="auto">
          <v-img width="48" contain :src="$asset('img/icons/siren.svg')" eager />
        </v-col>
        <v-col>
          <span v-html="$t('aeskulab.emergency')" />
        </v-col>
      </v-row>
    </div>
    <v-row>
      <v-col
        v-for="(value, key) in inputData.values"
        :key="key"
        cols="12"
        :sm="
          12 / (inputData.values.length % 2 === 0 || key !== inputData.values.length - 1 ? 2 : 1)
        "
      >
        <v-btn
          :color="value.htmlClass === 'self' ? 'primary' : 'tetrary'"
          block
          @click="updateValue(value.id)"
        >
          {{ getLocaleText(value.value) }}
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import formGtm from '@/mixins/formGtm';
import { required } from 'vuelidate/lib/validators';

export default {
  name: 'UlButtonsAeskulab',
  mixins: [formGtm],
  computed: {
    ...mapGetters({
      queryData: 'aeskulab/queryData'
    })
  },
  props: {
    inputData: {
      type: Object,
      required: true
    },
    stepId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      inputValue: null
    };
  },
  validations() {
    if (this.inputData.required) {
      return {
        inputValue: { required }
      };
    }
    return { inputValue: {} };
  },
  created() {
    this.$eventHub.$on(`validateInput_${this.inputData.id}_${this.stepId}`, () => this.validate());
    this.$eventHub.$on(`resetValidationInput_${this.inputData.id}_${this.stepId}`, () =>
      this.reset()
    );

    this.reset();
  },
  destroyed() {
    this.$eventHub.$off(`validateInput_${this.inputData.id}_${this.stepId}`);
    this.$eventHub.$off(`resetValidationInput_${this.inputData.id}_${this.stepId}`);
  },
  methods: {
    validate() {
      this.$store.commit('forms/emergencyDisclaimer/setIsEmergencyChecked', true);
      this.$v.$touch();
      this.$store.commit('dynamicForms/updateValidation', {
        id: this.inputData.id,
        value: !this.$v.$invalid,
        formName: this.formName
      });
    },
    reset() {
      if (this.$v) {
        this.$v.$reset();
      }
    },
    updateValue(id, emit = true) {
      this.$v.inputValue.$model = id;
      const gtmButtonType = this.inputData.values
        .find(val => val.id === id)
        .value.find(val => val.language === 'cs').text;
      this.gtmPush({ event: 'button_click', 'button.type': gtmButtonType, service: 'aeskulab' });
      this.validate();
      const updateResponsePayload = {
        id: this.inputData.id,
        value: this.inputValue,
        formName: this.formName
      };

      this.$store.dispatch('dynamicForms/updateResponse', updateResponsePayload);
      if (emit) {
        this.$emit('update:value');
      }
    }
  }
};
</script>
